import React from 'react';
import * as _ from 'lodash';

import {
  API_FLAG, // APIフラグ
  PREFECTURE_GROUPS, // 都道府県
  BILLING_FLAG, // 請求先フラグ
} from '../../utilities/constants';
import { isApiFlagOn, isApiFlagOff } from '../../utilities/commonUtil';

import { Tel } from '../Tel'; // 電話番号入力フィールド
import { PostalCode } from '../PostalCode'; // 郵便番号入力フィールド
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../CommonFormComponents';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { messageUtility } from '../../utilities/messageUtility';

const TextInput = props => {
  if (props.disabled) {
    return <span>{props.value}</span>;
  }
  return <input {...props} />;
};

/**
 * 元請会社支社フォーム
 * @param values {object} 入力値
 * @param events {func} イベントハンドラ
 * @param messages {object} バリデーションメッセージ
 * @param readOnly {boolean} プレビュー表示
 */
export const CompanyBranchForm = ({
  values,
  events,
  messages,
  readOnly = false,
  safetyDocItemFlag = false,
}) => (
  <div className='contruction-detail-view__main contruction-detail-view__main--fix contruction-detail-view__main--fixed'>
    <FormList>
      <FormListItem
        label='支店名'
        safetyDocItem={safetyDocItemFlag}
        required={!readOnly}
      >
        <FormElement validate={messages.name}>
          <TextInput
            type='text'
            name='name'
            disabled={readOnly}
            value={values.name}
            onChange={e => events.set('name', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='支店名ふりがな' required={!readOnly}>
        <FormElement validate={messages.kana}>
          <TextInput
            type='text'
            name='kana'
            disabled={readOnly}
            value={values.kana}
            onChange={e => events.set('kana', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem
        label='郵便番号'
        safetyDocItem={safetyDocItemFlag}
        required={!readOnly}
      >
        <PostalCode
          value={values.postal_code}
          handleOnChange={events.set}
          setKey='postal_code'
          readOnly={readOnly}
          error={messages.postal_code}
          validate={events.validate}
          placeholder=''
        />
      </FormListItem>
      <FormListItem
        label='都道府県'
        safetyDocItem={safetyDocItemFlag}
        required={!readOnly}
      >
        <FormElement validate={messages.prefectures_code_id}>
          <select
            name='prefectures_code_id'
            disabled={readOnly}
            value={values.prefectures_code_id}
            onChange={e => events.set('prefectures_code_id', e.target.value)}
            onBlur={e => events.validate(e)}
          >
            <option value=''>選択してください</option>
            {_.map(PREFECTURE_GROUPS, (region, index) => (
              <optgroup key={index} label={region.label}>
                {_.map(region.prefectures, prefecture => (
                  <option key={prefecture.id} value={prefecture.id}>
                    {prefecture.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </FormElement>
      </FormListItem>
      <FormListItem
        label='市区町村'
        safetyDocItem={safetyDocItemFlag}
        required={!readOnly}
      >
        <FormElement validate={messages.city_name}>
          <TextInput
            type='text'
            name='city_name'
            disabled={readOnly}
            value={values.city_name}
            placeholder={messageUtility.getMessage('I-000-190')}
            onChange={e => events.set('city_name', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem
        label={messageUtility.getMessage('I-000-188')}
        safetyDocItem={safetyDocItemFlag}
        required={!readOnly}
      >
        <FormElement validate={messages.street_number}>
          <TextInput
            type='text'
            name='street_number'
            disabled={readOnly}
            value={values.street_number}
            placeholder={messageUtility.getMessage('I-000-191')}
            onChange={e => events.set('street_number', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem
        label='建物名・部屋番号等'
        safetyDocItem={safetyDocItemFlag}
      >
        <FormElement validate={messages.building_name}>
          <TextInput
            type='text'
            name='building_name'
            disabled={readOnly}
            value={_.defaultTo(values.building_name, '')}
            placeholder='（例）赤坂ビルディング'
            maxLength={512}
            onChange={e => events.set('building_name', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='電話番号' required={!readOnly}>
        <Tel
          value={values.tel}
          handleOnChange={events.set}
          setKey='tel'
          readOnly={readOnly}
          error={messages.tel}
          validate={e => events.validate(e, 'tel')}
          placeholder=''
        />
      </FormListItem>
      <FormListItem label='FAX'>
        <Tel
          value={values.fax}
          readOnly={readOnly}
          handleOnChange={events.set}
          setKey='fax'
          error={messages.fax}
          validate={e => events.validate(e, 'fax')}
          placeholder=''
        />
      </FormListItem>
      <FormListItem label='担当者名' required={!readOnly}>
        <FormElement validate={messages.charge_name}>
          <TextInput
            type='text'
            name='charge_name'
            disabled={readOnly}
            value={values.charge_name}
            onChange={e => events.set('charge_name', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='担当者名ふりがな' required={!readOnly}>
        <FormElement validate={messages.charge_name_kana}>
          <TextInput
            type='text'
            name='charge_name_kana'
            disabled={readOnly}
            value={values.charge_name_kana}
            onChange={e => events.set('charge_name_kana', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='部署'>
        <FormElement validate={messages.department}>
          <TextInput
            type='text'
            name='department'
            disabled={readOnly}
            value={values.department}
            onChange={e => events.set('department', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='役職'>
        <FormElement validate={messages.job_title}>
          <TextInput
            type='text'
            name='job_title'
            disabled={readOnly}
            value={values.job_title}
            onChange={e => events.set('job_title', e.target.value)}
            onBlur={e => events.validate(e)}
          />
        </FormElement>
      </FormListItem>
      <FormListItem label='メールアドレス' required={!readOnly}>
        <FormElement validate={messages.email}>
          <TextInput
            type='text'
            name='email'
            disabled={readOnly}
            value={values.email}
            onChange={e => events.set('email', e.target.value)}
            onBlur={e => events.validate(e)}
            className='form-list__input-large'
          />
        </FormElement>
      </FormListItem>
      <FormListSubHeader title='請求先情報' />
      <FormListItem label='請求先'>
        <FormElement>
          {readOnly ? (
            <span>
              {values.billing_flag === BILLING_FLAG.on.id ? '上記と同じ' : ''}
            </span>
          ) : (
            <label htmlFor='billing_flag' className='checkbox'>
              <input
                type='checkbox'
                id='billing_flag'
                disabled={readOnly}
                checked={values.billing_flag === BILLING_FLAG.on.id}
                onClick={() =>
                  events.set(
                    'billing_flag',
                    values.billing_flag === BILLING_FLAG.on.id
                      ? BILLING_FLAG.off.id
                      : BILLING_FLAG.on.id
                  )
                }
              />
              <i className='i-square i-3x' aria-hidden='true' />
              上記と同じ
            </label>
          )}
        </FormElement>
      </FormListItem>
      {values.billing_flag !== BILLING_FLAG.on.id && (
        <React.Fragment>
          <FormListItem label='郵便番号' required={!readOnly}>
            <PostalCode
              value={values.billing_target.postal_code}
              handleOnChange={events.setBilling}
              setKey='postal_code'
              readOnly={readOnly}
              error={messages.billing_target_postal_code}
              validate={events.validate}
              placeholder=''
              isBilling={true}
            />
          </FormListItem>
          <FormListItem label='都道府県' required={!readOnly}>
            <FormElement validate={messages.billing_target_prefectures_code_id}>
              <select
                name='prefectures_code_id'
                disabled={readOnly}
                value={values.billing_target.prefectures_code_id}
                onChange={e =>
                  events.setBilling('prefectures_code_id', e.target.value)
                }
                onBlur={e => events.validate(e, '', true)}
              >
                <option value=''>選択してください</option>
                {_.map(PREFECTURE_GROUPS, (region, index) => (
                  <optgroup key={index} label={region.label}>
                    {_.map(region.prefectures, prefecture => (
                      <option key={prefecture.id} value={prefecture.id}>
                        {prefecture.name}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </FormElement>
          </FormListItem>
          <FormListItem label='市区町村' required={!readOnly}>
            <FormElement validate={messages.billing_target_city_name}>
              <TextInput
                type='text'
                name='city_name'
                disabled={readOnly}
                value={values.billing_target.city_name}
                placeholder={messageUtility.getMessage('I-000-190')}
                onChange={e => events.setBilling('city_name', e.target.value)}
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem
            label={messageUtility.getMessage('I-000-188')}
            required={!readOnly}
          >
            <FormElement validate={messages.billing_target_street_number}>
              <TextInput
                type='text'
                name='street_number'
                disabled={readOnly}
                value={values.billing_target.street_number}
                placeholder={messageUtility.getMessage('I-000-191')}
                onChange={e =>
                  events.setBilling('street_number', e.target.value)
                }
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='建物名・部屋番号等'>
            <FormElement validate={messages.billing_target_building_name}>
              <TextInput
                type='text'
                name='building_name'
                disabled={readOnly}
                value={_.defaultTo(values.billing_target.building_name, '')}
                placeholder='（例）赤坂ビルディング'
                maxLength={512}
                onChange={e =>
                  events.setBilling('building_name', e.target.value)
                }
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='電話番号' required={!readOnly}>
            <Tel
              value={values.billing_target.tel}
              handleOnChange={events.setBilling}
              setKey='tel'
              readOnly={readOnly}
              error={messages.billing_target_tel}
              validate={e => events.validate(e, 'tel', true)}
              placeholder=''
            />
          </FormListItem>
          <FormListItem label='FAX'>
            <Tel
              value={values.billing_target.fax}
              readOnly={readOnly}
              handleOnChange={events.setBilling}
              setKey='fax'
              error={messages.billing_target_fax}
              validate={e => events.validate(e, 'fax', true)}
              placeholder=''
            />
          </FormListItem>
          <FormListItem label='担当者名' required={!readOnly}>
            <FormElement validate={messages.billing_target_charge_name}>
              <TextInput
                type='text'
                name='charge_name'
                disabled={readOnly}
                value={values.billing_target.charge_name}
                onChange={e => events.setBilling('charge_name', e.target.value)}
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='担当者名ふりがな' required={!readOnly}>
            <FormElement validate={messages.billing_target_charge_name_kana}>
              <TextInput
                type='text'
                name='charge_name_kana'
                disabled={readOnly}
                value={values.billing_target.charge_name_kana}
                onChange={e =>
                  events.setBilling('charge_name_kana', e.target.value)
                }
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='部署'>
            <FormElement validate={messages.billing_target_department}>
              <TextInput
                type='text'
                name='department'
                disabled={readOnly}
                value={values.billing_target.department}
                onChange={e => events.setBilling('department', e.target.value)}
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='役職'>
            <FormElement validate={messages.billing_target_job_title}>
              <TextInput
                type='text'
                name='job_title'
                disabled={readOnly}
                value={values.billing_target.job_title}
                onChange={e => events.setBilling('job_title', e.target.value)}
                onBlur={e => events.validate(e, '', true)}
              />
            </FormElement>
          </FormListItem>
          <FormListItem label='メールアドレス' required={!readOnly}>
            <FormElement validate={messages.billing_target_email}>
              <TextInput
                type='text'
                name='email'
                disabled={readOnly}
                value={values.billing_target.email}
                onChange={e => events.setBilling('email', e.target.value)}
                onBlur={e => events.validate(e, '', true)}
                className='form-list__input-large'
              />
            </FormElement>
          </FormListItem>
        </React.Fragment>
      )}
      <FormListSubHeader title='その他設定情報' />
      <FormListItem label='新規現場の作成時の協力会社承認機能のデフォルト値'>
        {readOnly ? (
          <FormElement>
            {isApiFlagOn(values.use_partner_company_approval_default_flag)
              ? 'ON'
              : 'OFF'}
          </FormElement>
        ) : (
          <FormElement>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <input
                  type='radio'
                  id='form-radio-use_partner_company_approval_default_flag-1'
                  name='use_partner_company_approval_default_flag'
                  value={API_FLAG.On}
                  checked={isApiFlagOn(
                    values.use_partner_company_approval_default_flag
                  )}
                  disabled={readOnly}
                  onChange={e =>
                    events.set(
                      'use_partner_company_approval_default_flag',
                      Number(e.target.value)
                    )
                  }
                />
                <RadioButtonIcon className='icon--2x' />
                <span>ON</span>
              </label>
            </div>
            <div className='form-list-radio__item'>
              <label className='radio'>
                <input
                  type='radio'
                  id='form-radio-use_partner_company_approval_default_flag-2'
                  name='use_partner_company_approval_default_flag'
                  value={API_FLAG.Off}
                  checked={isApiFlagOff(
                    values.use_partner_company_approval_default_flag
                  )}
                  disabled={readOnly}
                  onChange={e =>
                    events.set(
                      'use_partner_company_approval_default_flag',
                      Number(e.target.value)
                    )
                  }
                />
                <RadioButtonIcon className='icon--2x' />
                <span>OFF</span>
              </label>
            </div>
          </FormElement>
        )}
      </FormListItem>
    </FormList>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/forms/PrimeBranch.jsx